/* tslint:disable */
/* eslint-disable */
/**
 * deliveryProviderPortal delivery-campaign-provider api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

export const DeliveryBonusType = {
        PERCENTAGE_OF_BASE_DELIVERY_PRICE: 'percentage_of_base_delivery_price',
        PERCENTAGE_OF_FULL_DELIVERY_PRICE: 'percentage_of_full_delivery_price',
        PERCENTAGE_OF_FOOD_PRICE: 'percentage_of_food_price',
        PERCENTAGE_OF_FOOD_PRICE_WITH_DISCOUNT_CAP: 'percentage_of_food_price_with_discount_cap',
        PRICE_LIST_FOR_MENU_ITEMS: 'price_list_for_menu_items',
        DOUBLE_DEAL: 'double_deal',
        PERCENTAGE_OF_FEE: 'percentage_of_fee',
        PERCENTAGE_CASHBACK_OF_FOOD_PRICE: 'cashback_percentage_of_food_price',
        AMOUNT_CASHBACK_OF_FOOD_PRICE: 'cashback_amount_of_food_price'
} as const;
export type DeliveryBonusType = typeof DeliveryBonusType[keyof typeof DeliveryBonusType];

